import React from 'react';
import PropTypes from 'prop-types';

import MarkdownRenderer from './MarkdownRenderer.jsx';

const AnswerPart = ({ content }) => {
  if (!content) return null;

  return (
    <div className="bg-bg-message-ai text-primary py-spacing-1 w-full break-words min-w-0 mb-spacing-4 px-spacing-2 text-dls-body">
      <MarkdownRenderer content={content} />
    </div>
  );
};

AnswerPart.propTypes = {
  content: PropTypes.string.isRequired,
};

export default AnswerPart;

